import { render, staticRenderFns } from "./LocalProfile.Dialog.vue?vue&type=template&id=42c5e47f&scoped=true"
import script from "./LocalProfile.Dialog.vue?vue&type=script&lang=js"
export * from "./LocalProfile.Dialog.vue?vue&type=script&lang=js"
import style0 from "./LocalProfile.Dialog.vue?vue&type=style&index=0&id=42c5e47f&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42c5e47f",
  null
  
)

export default component.exports